import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
import { ChevronRight, Search } from '@mui/icons-material';
import OfferCard from '../components/OfferCard';

const perks = [
    {
        company: "Tesla",
        ticker: "TSLA",
        title: "Early Cyber Cab Access",
        description:
            "Priority access to Tesla's autonomous taxi service in launch cities",
        logo: "https://cdn.govotr.com/logos/TSLA.png",
        image:
            "/access/teslaCar.webp",
        sharesRequired: "150+ Shares Required",
        shares: 150,
        remaining: "Limited spots available",
    },
    {
        company: "Disney",
        ticker: "DIS",
        title: "Flash Pass - Skip the Lines",
        description:
            "Premium access allowing shareholders to bypass regular queues at all Disney parks worldwide",
        logo: "https://cdn.govotr.com/logos/DIS.png",
        image:
            "/access/disney1.webp",
        sharesRequired: "500+ Shares Required",
        shares: 500,
        remaining: "Limited spots available",
    },
    {
        company: "Live Nation",
        ticker: "LYV",
        title: "Priority Access on Ticket",
        description:
            "First-access window for concert and event tickets before general public sales",
        logo: "https://images.crunchbase.com/image/upload/c_pad,h_170,w_170,f_auto,b_white,q_auto:eco,dpr_1/gcr4anfpo8lxetdnolvp",
        image:
            "/access/live1.webp",
        sharesRequired: "350+ Shares Required",
        shares: 350,
        remaining: "Limited spots available",
    },
    {
        company: "Delta",
        ticker: "DAL",
        title: "Delta One Upgrade Access",
        description:
            "Complimentary upgrades to Delta One (when available) on international flights",
        // logo:"",
        // image:
        //   "https://www.delta.com/content/dam/delta-com/products/delta-experiences/delta-one/d1-seat-drink-man-privacy-1042.jpg",
        sharesRequired: "2000+ Shares Required",
        shares: 2000,
        remaining: "Limited spots available",
        logo: "https://cdn.govotr.com/logos/DAL.png",
        image:
            "/access/delta1.webp",
    },
    {
        company: "Starbucks",
        ticker: "SBUX",
        title: "Skip the Line Access",
        description:
            "Enjoy exclusive VIP mobile ordering privileges, with the added benefit of dedicated pickup service at all locations for your convenience.",
        logo: "https://cdn.govotr.com/logos/SBUX.png",
        image:
            "/access/starbuck1.webp",
        sharesRequired: "500+ Shares Required",
        shares: 500,
        remaining: "Limited spots available",
    },
    {
        company: "Nike",
        ticker: "NKE",
        title: "Travis Scott Shoe Drop Access",
        description:
            "Guaranteed exclusive access to highly sought-after, limited edition Travis Scott collaborations that you won't want to miss!",
        logo: "https://cdn.govotr.com/logos/NKE.png",
        image:
            "/access/nike1.webp",
        sharesRequired: "500+ Shares Required",
        shares: 500,
        remaining: "Limited spots available",
    },
    {
        company: "Chipotle",
        ticker: "CMG",
        title: "Double Meat + Free Guac",
        description:
            "Premium meal upgrades on every order with verified shareholder status",
        logo: "https://cdn.govotr.com/logos/CMG.png",
        image:
            "/access/chip-pic.webp",
        sharesRequired: "100+ Shares Required",
        shares: 100,
        remaining: "Limited spots available",
    },
    {
        company: "Airbnb",
        ticker: "ABNB",
        title: "Access to Icon Properties",
        description:
            "Early booking window for Airbnb's most exclusive and unique properties",
        // image:
        //   "https://news.airbnb.com/wp-content/uploads/sites/4/2024/04/02-The-Up-House-Icons-Airbnb-Credit-Ryan-Lowry.jpg?fit=2662,1776",
        sharesRequired: "1000+ Shares Required",
        shares: 1000,
        remaining: "Limited spots available",
        logo: "https://cdn.govotr.com/logos/ABNB.png",
        image:
            "/access/airbnb1.webp",
    },
    {
        company: "Chase",
        ticker: "JPM",
        title: "VIP Private Concierge",
        description:
            "24/7 dedicated concierge service for premium banking and lifestyle requests",
        logo: "https://cdn.govotr.com/logos/JPM.png",
        image:
            "/access/chase1.webp",
        sharesRequired: "2500+ Shares Required",
        shares: 2500,
        remaining: "Limited spots available",
    },
];

const ContentHub: React.FC = () => {
    const [filter, setFilter] = useState("all");
    // const navigate = useNavigate();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [, setSelectedOption] = useState("Offer Type");
    const handleSelect = (option: string) => {
        setSelectedOption(option);
        setDropdownOpen(false);
    };
    return (
        <div className="min-h-screen">
            <div
                className="h-auto bg-cover bg-center px-2 md:px-8 pt-4 pb-0 md:pb-10 "
                style={{
                    backgroundImage: `url('/access/banner.png')`,
                }}
            >
                {/* sample */}
                <div className="flex items-center bg-[#FFFFFF26] rounded-md shadow-md mb-5 max-w-7xl mx-auto ">
                    {/* Search Input */}
                    <div className="flex-1 relative w-full">
                        <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 h-5 w-5 text-[#9D9FAA]" />
                        <input
                            type="text"
                            placeholder="Offer, Issuer, Store etc"
                            className="w-full bg-transparent sm:border-r border-[#54575E] text-[#9D9FAA] placeholder:text-[#9D9FAA] pl-12 py-3 rounded-none focus:outline-none  focus:ring-[#2C2C2C]"
                        />
                    </div>

                    {/* Dropdown and Search Buttons */}
                    <div className="hidden sm:flex">
                        {/* Offer Type Dropdown */}
                        <div className="relative">
                            <button
                                className="flex items-center justify-between text-white px-6 py-3 rounded-lg w-full sm:w-auto transition-all"
                            // onClick={() => setDropdownOpen(!dropdownOpen)}
                            >
                                <span className="flex gap-2">
                                    {" "}
                                    <img src="/access/filterIcon.svg" alt="Filter icon" /> Offer Type
                                </span>
                                <svg
                                    className={`h-5 w-5 ml-2 transition-transform ${dropdownOpen ? "rotate-180" : ""
                                        }`}
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M19 9l-7 7-7-7"
                                    />
                                </svg>
                            </button>
                            {dropdownOpen && (
                                <ul className="absolute z-10 w-full bg-[#1C1C1C] border border-[#54575E] text-white rounded-lg shadow-md mt-2">
                                    <li
                                        className="px-4 py-2 hover:bg-[#3C3C3C] cursor-pointer"
                                        onClick={() => handleSelect("Option 1")}
                                    >
                                        Option 1
                                    </li>
                                    <li
                                        className="px-4 py-2 hover:bg-[#3C3C3C] cursor-pointer"
                                        onClick={() => handleSelect("Option 2")}
                                    >
                                        Option 2
                                    </li>
                                    <li
                                        className="px-4 py-2 hover:bg-[#3C3C3C] cursor-pointer"
                                        onClick={() => handleSelect("Option 3")}
                                    >
                                        Option 3
                                    </li>
                                </ul>
                            )}
                        </div>

                        {/* Search Button */}
                        <button className="flex items-center justify-center bg-[#D63B3B] text-white px-8 py-3 rounded-lg hover:bg-[#E04A4A] focus:ring-2 focus:ring-[#FF5A5A] transition-all">
                            Search
                        </button>
                    </div>
                </div>
                {/* sample */}

                <div className="overflow-x-auto scrollbar-hide max-w-7xl mx-auto  ">
                    <div className="flex space-x-4 mb-6 min-w-max">
                        <button
                            onClick={() => setFilter("all")}
                            className={`px-4 py-2 rounded-full ${filter === "all"
                                ? "bg-[#D63B3B] text-white  "
                                : "text-white bg-[#FFFFFF33] hover:bg-[#D63B3B] hover:text-white"
                                }`}
                        >
                            All Access
                        </button>
                        <button
                            onClick={() => setFilter("qualified")}
                            className={`px-4 py-2 rounded-full ${filter === "qualified"
                                ? "bg-[#D63B3B] text-white   "
                                : "text-white bg-[#FFFFFF33] hover:bg-[#D63B3B] hover:text-white "
                                }`}
                        >
                            Qualified
                        </button>
                        <button
                            onClick={() => setFilter("potential")}
                            className={`px-4 py-2 rounded-full ${filter === "potential"
                                ? "bg-[#D63B3B] text-white  "
                                : "text-white bg-[#FFFFFF33] hover:bg-[#D63B3B] hover:text-white"
                                }`}
                        >
                            Potential
                        </button>
                        <button
                            onClick={() => setFilter("claimed")}
                            className={`px-4 py-2 rounded-full ${filter === "claimed"
                                ? "bg-[#D63B3B] text-white  "
                                : "text-white bg-[#FFFFFF33] hover:bg-[#D63B3B] hover:text-white"
                                }`}
                        >
                            Claimed
                        </button>
                    </div>
                </div>

                <div className="flex flex-row sm:flex-col justify-between sm:justify-start sm:items-start items-center mb-6 pb-12 md:pb-3 max-w-7xl mx-auto ">
                    <div className="text-xl sm:text-2xl text-white font-semibold">
                        Available Access
                    </div>
                    <div className="text-sm text-[#6B6B6B] h-full flex items-center gap-2">
                        Powered by <img className="h-4 " src="/access/votr_white.png" alt="VOTR logo" />
                    </div>

                    {/* <div className="text-sm text-[#6B6B6B]">Powered by VOTR</div> */}
                </div>
            </div>

            <div className="w-full max-w-7xl mx-auto relative">
                <div className="w-full py-4 absolute top-[-70px] md:top-[-40px] px-4 mx-auto ">
                    {/* First Row of Perks */}
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 mb-8">
                        {perks.slice(0, 3).map((perk, index) => (
                            <div
                                key={index}
                                className="bg-white rounded-lg overflow-hidden cursor-pointer p-2  hover:shadow-xl hover:scale-105 hover:bg-gray-50  transition-transform flex flex-row sm:flex-col "
                                // className="bg-[#1C1C1C] rounded-lg overflow-hidden cursor-pointer"
                                style={{
                                    boxShadow: "0px 23px 44px 0px rgba(176, 183, 195, 1)",
                                }}
                            // onClick={() =>
                            //     navigate(
                            //         `/${perk.company.replace(/\s+/g, "-").toLowerCase()}`,
                            //         { state: { shares: perk.shares } }
                            //     )
                            // }
                            >
                                <div className="flex-1">
                                    <img
                                        src={perk.image}
                                        alt={perk.title}
                                        className="w-full h-48 object-cover rounded-md"
                                    />
                                </div>
                                <div className="p-4 flex-1 flex flex-col justify-between h-full">
                                    <div className="flex items-center gap-2 mb-2">
                                        <span className="text-[#D63B3B]">
                                            <img
                                                src={perk.logo}
                                                className="h-4 rounded-full"
                                                alt={`${perk.company} logo`}
                                            />
                                        </span>
                                        <span className="text-black font-medium">
                                            {perk.ticker}
                                        </span>
                                    </div>
                                    <h3 className="text-black text-lg font-semibold mb-2">
                                        {perk.title}
                                    </h3>
                                    <div className="flex flex-wrap gap-2 mt-auto">
                                        <span className="bg-[#D0F5E1] text-[#34A853] text-sm font-semibold px-2 py-1 rounded">
                                            {perk.sharesRequired}
                                        </span>
                                        {/* <span className="bg-[#F0F1FF] text-[#5263FF] text-sm font-semibold px-2 py-1 rounded flex items-center gap-2">
                      <img src="/votr_purple.png" className="h-5 w-5 p-0.5" />
                      VOTR ACCESS{" "}
                    </span> */}
                                    </div>
                                    <div className="mt-4 text-sm text-[#6B6B6B]  hidden sm:visible">
                                        {perk.remaining}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="flex items-center justify-between">
                        <div className="flex flex-col items-start gap-2 mb-6">
                            <h2 className="text-xl sm:text-2xl text-black font-semibold">
                                Potential Access
                            </h2>
                            <div className="text-sm text-[#6B6B6B] flex items-end justify-center gap-2">
                                Powered by <img className="h-4 " src="/access/votr_black.png" alt="VOTR logo" />
                            </div>
                        </div>
                        <div className="text-[#0038FF] font-medium flex gap-3 cursor-pointer">
                            View All <ChevronRight />
                        </div>
                    </div>
                    {/* Remaining Perks */}
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                        {perks.slice(3).map((perk, index) => (
                            <>
                                {index === 3 ? (
                                    <div className="col-span-3 hidden lg:block lg:col-span-0">
                                        <OfferCard />
                                    </div>
                                ) : null}
                                <div
                                    key={index}
                                    // onClick={() =>
                                    //     navigate(
                                    //         `/${perk.company.replace(/\s+/g, "-").toLowerCase()}`,
                                    //         { state: { shares: perk.shares } }
                                    //     )
                                    // }
                                    className="bg-white rounded-lg overflow-hidden cursor-pointer p-2 hover:shadow-xl hover:scale-105 hover:bg-gray-50  transition-transform flex flex-row sm:flex-col "
                                    style={{
                                        boxShadow: "0px 23px 44px 0px rgba(176, 183, 195, 1)",
                                    }}
                                >
                                    <div className="flex-1">
                                        <img
                                            src={perk.image}
                                            alt={perk.title}
                                            className="w-full h-48 object-cover rounded-md"
                                        />
                                    </div>
                                    <div className="p-4 flex-1 flex flex-col justify-between h-full">
                                        <div className="flex items-center gap-2 mb-2">
                                            <span className="text-[#D63B3B]">
                                                <img
                                                    src={perk.logo}
                                                    className="h-4 rounded-full"
                                                    alt={`${perk.company} logo`}
                                                />
                                            </span>
                                            <span className="text-black font-medium">
                                                {perk.ticker}
                                            </span>
                                        </div>
                                        <h3 className="text-black text-lg font-semibold mb-2">
                                            {perk.title}
                                        </h3>
                                        <div className="flex flex-wrap gap-2 mt-auto ">
                                            <span className="bg-[#FBD8D5] text-[#EA4334] font-semibold text-sm px-2 py-1 rounded">
                                                {perk.sharesRequired}
                                            </span>
                                            {/* <span className="bg-[#F0F1FF] text-[#5263FF] text-sm font-semibold px-2 py-1 rounded flex items-center gap-2">
                        <img
                          src="/votr_purple.png"
                          className="h-5 w-5 p-0.5 "
                        />
                        VOTR ACCESS{" "}
                      </span> */}
                                        </div>
                                        <div className="mt-4 text-sm text-[#6B6B6B] hidden sm:block">
                                            {perk.remaining}
                                        </div>
                                    </div>
                                </div>
                            </>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContentHub; 